//import { useHistory } from "react-router-dom";
//import authService from '../components/api-authorization/AuthorizeService';
//import { QueryParameterNames, ApplicationPaths } from '../components/api-authorization/ApiAuthorizationConstants';
import { toast } from 'react-toastify';

export { useFetchWrapper };

function useFetchWrapper() {
    //const history = useHistory();

    const request = (method) => {
      return async (url, body) => {
        //const [isAuthenticated, authToken] = await Promise.all([authService.isAuthenticated(), authService.getAccessToken()])
        //const authToken = await authService.getAccessToken()

          const requestOptions = {
              method,
              headers: {}//authHeader(url, authToken)
          };
          requestOptions.headers['redirect'] = 'follow';
          if (body) {
              requestOptions.headers['Content-Type'] = 'application/json';
              requestOptions.body = JSON.stringify(body);
          }

          return fetch(url, requestOptions).then((response) => handleResponse(response /*, authToken*/));
      }
  }
    
    // helper functions
    
    // function authHeader(url, authToken) {
    //     // return auth header with jwt if user is logged in and request is to the api url
    //     //const [isAuthenticated, authToken] = await Promise.all([authService.isAuthenticated(), authService.getAccessToken()])
    //     //Promise.all([authService.isAuthenticated(), authService.getAccessToken()]).then(([isAuthenticated, authToken]) => {

    //       const isLoggedIn = !!authToken;
    //       //const isApiUrl = url.startsWith(process.env.REACT_APP_API_URL);

    //       //console.log('isLoggedIn: ', isLoggedIn)
    //       //console.log('isApiUrl: ', isApiUrl)

    //       if (isLoggedIn) { //} && isApiUrl) {
    //         //console.log('returning auth bearer')
    //         //console.log({ 'Authorization': `Bearer ${authToken}` })
    //           return { 'Authorization': `Bearer ${authToken}` };
    //       } else {
    //           return {};
    //       }
    //     //});
    // }
    
    function handleResponse(response /*, authToken*/) {
        return new Promise((resolve, reject) => { 
        return response.text().then(text => {
    
        let data = undefined
        try
        {
            data = text && JSON.parse(text);
        }
        catch
        {
            data = { message: "Unexpected response: " + response.status }
        }

        if (!response.ok) {
            if ([401, 403].includes(response.status) /*&& authToken*/) {
                // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                const returnUrl = window.location.origin;
                //const loginReturnUrl = `${window.location.origin}/${ApplicationPaths.Login}?${QueryParameterNames.ReturnUrl}=${encodeURIComponent(returnUrl)}`

                console.log(returnUrl)

                //const returnUrl = `?${QueryParameterNames.ReturnUrl}=${encodeURI(ApplicationPaths.Login)}`
                // const logoutPath = {
                //     pathname: `${ApplicationPaths.LogOut}`,
                //     search: `?${QueryParameterNames.ReturnUrl}=${encodeURIComponent(loginReturnUrl)}`,
                //     state: { local: true }
                // };
                // history.push(logoutPath)

                data = { message: `Login Necessary (${response.status})` }
                window.location.href = returnUrl;
            }
            else if (response.redirected) {
                data = { message: `Redirecting (${response.status})` }
                window.location.href = response.url;
            }

            const error = (data && data.message) || (data && data.title) || response.statusText;
            toast.error(error, {
                toastId: 'fetch-wrapper-toast-id',
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
            })
            return reject(error);
        }

        return resolve(data);
    })})
        

    }

    return {
          get: request('GET'),
          post: request('POST'),
          put: request('PUT'),
          delete: request('DELETE')
        }
}